'use client';

import { DATADOG_RUM_NAME, useConsent } from '@lichtblick/consent';
import { logger } from '@lichtblick/logger';
import { useEffect } from 'react';

export const DatadogRum = () => {
  const datadogRumState = useConsent(DATADOG_RUM_NAME);

  useEffect(() => {
    const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
    const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
    const service = process.env.NEXT_PUBLIC_DATADOG_SERVICE_NAME;

    if (!datadogRumState) {
      return;
    }

    import('@datadog/browser-rum').then(({ datadogRum }) => {
      try {
        if (!datadogRum.getInitConfiguration() && applicationId && clientToken && service) {
          datadogRum.init({
            applicationId,
            clientToken,
            service,
            site: 'datadoghq.eu',
            env: process.env.NEXT_PUBLIC_STAGE,
            version: process.env.NEXT_PUBLIC_VERSION,
            sessionReplaySampleRate: 20,
            sessionSampleRate: 100,
            startSessionReplayRecordingManually: true,
            storeContextsAcrossPages: true,
            trackUserInteractions: true,
            trackResources: true,
            trackViewsManually: true,
            allowedTracingUrls: [
              /https:\/\/graph(tst|dev|)\.lichtblick\.de.*/,
              /https:\/\/www\.lichtblick\.de.*/,
              /https:\/\/.+\.lb-dev\.site.*/,
            ],
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask-user-input',
            beforeSend: (event) => {
              if (!datadogRumState && event.type !== 'view') {
                return false;
              }

              // Filter out load static props error until fixed to reduce noise
              if (event.type === 'error' && event.error.message === 'Error: Failed to load static props') {
                return false;
              }

              return true;
            },
          });

          datadogRum.onReady(() => {
            const htmlEl = document.querySelector('html');

            if (!htmlEl) {
              // sure
              return;
            }

            if (htmlEl.lang !== 'de') {
              datadogRum.addAction('translated-page', { lang: htmlEl.lang });

              return;
            }

            const observer = new MutationObserver(() => {
              const lang = htmlEl.lang;

              if (lang !== 'de') {
                datadogRum.addAction('translated-page', { lang });
                observer.disconnect();
              }
            });

            observer.observe(htmlEl, { attributes: true, attributeFilter: ['lang'] });
          });
        }
      } catch (error) {
        logger.error('datadog RUM error', { error });
      }
    });
  }, [datadogRumState]);

  return null;
};
